"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationsCarousel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _excluded = ["inverse", "integrations", "overflowLabel"],
    _excluded2 = ["media", "name", "image"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var IntegrationsWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e12c4hqe3"
} : {
  target: "e12c4hqe3",
  label: "IntegrationsWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "18znnq9",
  styles: "display:flex;align-items:center;gap:10px;margin-top:20px"
} : {
  name: "18znnq9",
  styles: "display:flex;align-items:center;gap:10px;margin-top:20px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Media = (0, _theming.styled)("figure", process.env.NODE_ENV === "production" ? {
  target: "e12c4hqe2"
} : {
  target: "e12c4hqe2",
  label: "Media"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var _ref = process.env.NODE_ENV === "production" ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : {
  name: "1bbgfb-Integration",
  styles: "opacity:0.5;label:Integration;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Integration = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Button, process.env.NODE_ENV === "production" ? {
  target: "e12c4hqe1"
} : {
  target: "e12c4hqe1",
  label: "Integration"
})("border-radius:", _styles.spacing.borderRadius.small, "px;padding:8px;background-color:", function (props) {
  return props.color || 'transparent';
}, ";", function (props) {
  return props.inverse && /*#__PURE__*/(0, _theming.css)("box-shadow:rgb(255 255 255 / 10%) 0 0 0 1px inset;&:hover,&:active,&:focus,&:active:focus:hover{box-shadow:", _styles.color.secondary, " 0 0 0 1px inset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Integration;"));
}, " ", function (props) {
  return props.active ? /*#__PURE__*/(0, _theming.css)("box-shadow:", _styles.color.secondary, " 0 0 0 1px inset;" + (process.env.NODE_ENV === "production" ? "" : ";label:Integration;")) : _ref;
}, " span{display:block;}img{display:block;width:24px;height:24px;object-fit:contain;}");
Integration.defaultProps = {
  appearance: 'outline',
  containsIcon: true
};
var OverflowLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e12c4hqe0"
} : {
  target: "e12c4hqe0",
  label: "OverflowLabel"
})(_styles.text.regular, ";color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.5)' : _styles.color.mediumdark;
}, ";");

var IntegrationsCarousel = function IntegrationsCarousel(_ref2) {
  var inverse = _ref2.inverse,
      integrations = _ref2.integrations,
      overflowLabel = _ref2.overflowLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var activeIntegration = integrations[activeIndex];
  var ref = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(Media, null, activeIntegration.media), /*#__PURE__*/_react["default"].createElement(IntegrationsWrapper, null, integrations.map(function (_ref3, index) {
    var media = _ref3.media,
        name = _ref3.name,
        image = _ref3.image,
        integration = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(Integration, (0, _extends2["default"])({
      inverse: inverse,
      key: name,
      active: name === activeIntegration.name,
      onClick: function onClick() {
        setActiveIndex(index);
      }
    }, integration), /*#__PURE__*/_react["default"].createElement("img", {
      src: image,
      alt: name
    }));
  }), /*#__PURE__*/_react["default"].createElement(OverflowLabel, {
    inverse: inverse
  }, overflowLabel)));
};

exports.IntegrationsCarousel = IntegrationsCarousel;